import { useEffect } from "react";
/**
 * Пока нижний плеер-бар смонтирован — публикуем его РЕАЛЬНУЮ высоту в
 * CSS-переменную `--vp-player-h` на `<body>`. Контент/поля ввода резервируют
 * это место снизу (`padding-bottom` / сдвиг `bottom`), чтобы бар их не перекрывал.
 * На размонтировании/паузе бара — сбрасываем в `0px`.
 *
 * Высоту меряем через ResizeObserver (бар выше на мобиле — прогресс переносится
 * на отдельную строку), поэтому не угадываем константой.
 */
export function useReportPlayerBarHeight(ref, active) {
    useEffect(() => {
        const clear = () => document.body.style.setProperty("--vp-player-h", "0px");
        const el = ref.current;
        if (!active || !el) {
            clear();
            return clear;
        }
        const apply = () => document.body.style.setProperty("--vp-player-h", `${el.offsetHeight}px`);
        apply();
        const ro = new ResizeObserver(apply);
        ro.observe(el);
        return () => {
            ro.disconnect();
            clear();
        };
    }, [ref, active]);
}
